import { mdiPencilBoxMultipleOutline } from '@mdi/js'

export default [
  {
    title: 'Score',
    to: 'score-list',
    icon: mdiPencilBoxMultipleOutline,
  },
]
